import React, { useEffect } from "react";
import "./Project.css";

const Projects = () => {
  const scrollToTop = () => {
    window.scrollTo({
      top: 0,
      behavior: "smooth",
    });
  };
  useEffect(() => {
    scrollToTop();
  }, []);

  const projectList = [
    {
      title: "Lucid Vodka",
      description: "Developed a premium brand website for Lucid Vodka to showcase its signature flavors and curated cocktail recipes, delivering an immersive and visually refined digital experience aligned with the brand’s identity.",
      duration: "2 Months",
      status: "Completed",
      color: "text-green-500"
    },
    {
      title: "Arrow Interior",
      description: "Created a responsive company website for Arrow Interior using modern UI principles, featuring structured service descriptions, product showcases, completed project galleries, and optimized contact and inquiry flows to support business growth.",
      duration: "2 Months",
      status: "Completed",
      color: "text-green-500"
    },
    {
      title: "Blue Mango Consulting Group",
      description: "Created a modern, responsive consulting firm website for Blue Mango Consulting Group (BMCG) with intuitive navigation, service showcases, expert profiles, and scheduling functionality to allow seamless appointment setup with business and industrial growth advisors.",
      duration: "2 Months",
      status: "Completed",
      color: "text-green-500"
    },
    {
      title: "Your Global Catalyst",
      description: "Built a podcast and newsletter platform for Your Global Catalyst featuring a custom admin panel for content publishing and a user-facing site for accessing curated insights. The platform supports the organization’s mission of promoting better thinking, strategic clarity, and global knowledge sharing.",
      duration: "4 Months",
      status: "Completed",
      color: "text-green-500"
    },
    {
      title: "Viesharaa",
      description: "Developing an e-commerce website for Viesharaa, a premium silk saree brand, designed to showcase traditional and contemporary saree collections. The platform is structured to support product browsing, wishlist functionality, cart management, and secure online payments through Razorpay integration.",
      duration: "4 Months",
      status: "Pending",
      color: "text-orange-500"
    }
  ];

  return (
    <div className="bg-gray-50 min-h-screen py-20 px-4">
      <div className="max-w-7xl mx-auto">
        {/* <h2 className="text-4xl md:text-5xl text-center uppercase font-black text-gray-900 mb-16 tracking-tighter">
          <span className="relative inline-block">
            Selected Projects
            <div className="absolute -bottom-2 left-0 w-full h-1.5 bg-sky-500 rounded-full"></div>
          </span>
        </h2> */}

        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-10">
          {projectList.map((project, index) => (
            <div
              key={index}
              className="group relative bg-white rounded-3xl overflow-hidden shadow-xl transition-all duration-500 border border-gray-100"
            >
              {/* Card Header/Image Area */}
              <div className="h-56 bg-gradient-to-br from-gray-900 via-gray-800 to-sky-900 relative overflow-hidden flex items-center justify-center">
                <div className="absolute inset-0 bg-[url('https://www.transparenttextures.com/patterns/cubes.png')] opacity-10"></div>
                <div className="relative text-7xl font-black text-white/10 scale-150 uppercase italic">
                  {project.title.charAt(0)}
                </div>
                <div className="absolute bottom-4 left-6">
                  <span className={`text-[10px] font-black uppercase tracking-[0.3em] ${project.color} bg-white/10 backdrop-blur-md px-3 py-1 rounded-full border border-white/20 shadow-xl`}>
                    {project.status}
                  </span>
                </div>
              </div>

              {/* Card Content Area */}
              <div className="p-8">
                <div className="flex justify-between items-center mb-4">
                  <h3 className="text-2xl font-black text-gray-900 tracking-tighter leading-none">
                    {project.title}
                  </h3>
                </div>

                <p className="text-gray-500 text-sm mb-8 leading-relaxed font-medium">
                  {project.description}
                </p>

                <div className="pt-6 border-t border-gray-100 flex items-center justify-between">
                  <div className="flex items-center text-gray-400 text-[10px] font-black uppercase tracking-widest">
                    <svg className="w-4 h-4 mr-2 text-sky-500" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                      <path strokeLinecap="round" strokeLinejoin="round" strokeWidth="3" d="M12 8v4l3 3m6-3a9 9 0 11-18 0 9 9 0 0118 0z" />
                    </svg>
                    {project.duration}
                  </div>
                </div>
              </div>

              {/* Hover Accent */}
              <div className="absolute top-0 left-0 w-1.5 h-full bg-sky-500 transform -translate-x-full group-hover:translate-x-0 transition-transform duration-300"></div>
            </div>
          ))}
        </div>
      </div>
    </div>
  );
};

export default Projects;
